export const ORANGE = '#eb6500';
export const N7 = '#737373';
export const N10 = '#2E2E2E';
export const BASE_SPACE = 16;
export const CHART_HEIGHT = BASE_SPACE * BASE_SPACE;
